export default __webpack_public_path__ + "media/images/gradient2-ba6a5093ccba7fa043a8aa086e7815fb.png";